
<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :addButtonIcon="addButtonIcon"
    :showButton="showButton"
    :newCreateButtonLabel="newCreateButtonLabel"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    newButton: {
      type: Boolean,
      default: false,
    },
    addButtonIcon: {
      type: String,
      default: "mdi-plus"
    },
    modelNameSingular: String,
    parentId: {
      type: String,
      default: null,
    },
    showButton:{
      type: Boolean,
      default: true,
    },
    newCreateButtonLabel: {
      type: String,
      default: function() {
        return "Adicionar " + this.modelNameSingular
      }
    },
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_AGENDA_QUERY,
          fetchPolicy: "no-cache",
          variables:{
            parentId: this.parentId,
          }
        })
        .then(response => {
          this.entry = response.data.accountContext.agenda;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(agenda) {
      // console.log("SUBCULTURE", agenda, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(agenda, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_AGENDA_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(agenda, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createAgenda.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createAgenda.agenda);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_AGENDA_QUERY = gql `
  query($parentId: ID){
    accountContext{
      agenda(parentId: $parentId) {
        id
        personId
        customerId
        destinyAddressId
        parentId
        validations
      }
      agendaStatuses
      agendaPriorityTypes
      agendaContacts
      allMyEmployees{
        id
        name
        isSupervisor
        isSeller
      }
      allMyCustomers{
        id
        name
        sellerId
      }
    } 
  }
`;

const CREATE_AGENDA_MUTATION = gql `
  mutation($input: AgendaCreateInputObject!) {
    createAgenda(input: $input) {
      agenda {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

